import { Button } from "@components/Helpers/UIComponents";
import { RadioButtonProps } from "@interfaces/uiElementTypes";

const RadioButton: React.FC<RadioButtonProps> = ({
  label,
  value,
  checked,
  onChange,
}) => {
  return (
    <Button
      className={`radio_button cursor-pointer !justify-start ${
        checked
          ? "border-primary-500 bg-primary-500 bg-opacity-10"
          : "border-radio_border"
      }`}
      onClick={() => onChange(value)}
    >
      <input
        type="radio"
        name={value}
        id={value}
        value={value}
        onChange={() => onChange(value)}
        className="hidden"
      />
      <div
        className={`nav_button mr-3 h-[20px] w-[20px] border-2 ${
          checked ? "border-primary-500" : "border-radio_button"
        }`}
      >
        {checked && (
          <div className="h-[10px] w-[10px] rounded-full bg-primary-500"></div>
        )}
      </div>
      <span className="flex grow justify-start">{label}</span>
    </Button>
  );
};

export default RadioButton;
